import fetch from "auth/FetchInterceptor";

const ReportService = {};

ReportService.fetchTestLevelReport = function (payload) {
  return fetch({
    url: "/test-level-report",
    data: payload,
    method: "post",
  });
};

ReportService.fetchDailyReport = function (payload) {
  return fetch({
    url: "/daily-report",
    data: payload,
    method: "post",
  });
};

export default ReportService;
